import { render, staticRenderFns } from "./couponContent.vue?vue&type=template&id=772d0d4d&scoped=true"
import script from "./couponContent.vue?vue&type=script&lang=js"
export * from "./couponContent.vue?vue&type=script&lang=js"
import style0 from "./couponContent.vue?vue&type=style&index=0&id=772d0d4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d0d4d",
  null
  
)

export default component.exports